import * as React from 'react'
import type { Unit } from './unit'
import { initialPromiseState, type PromiseState } from '../util/PromiseState'
import { cancelPromiseManagers, createPromiseManager } from '../util/PromiseManager'
import { createStateLens } from '../util/react'
import { Pulse } from '../ui/Pulse'
import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import classNames from 'classnames'
import type { BarcodeResult } from './barcodeTypes'

interface Props {
    deps: CommonDeps
    units: Unit[]
    barcodeScanForUnits: (units: Unit[]) => Promise<BarcodeResult>
    onSelect: (result: BarcodeResult) => Promise<void> | void
    className?: string
}

interface State {
    barcodeState: PromiseState<void>
}

export class BarcodeButton extends React.Component<Props, State> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    public state: State = {
        barcodeState: initialPromiseState,
    }

    public promiseManagers = {
        barcodeState: createPromiseManager(() => this.props.deps, createStateLens(this, 'barcodeState')),
    }

    public componentWillUnmount() {
        cancelPromiseManagers(this.promiseManagers)
    }

    private onClick = () => {
        this.promiseManagers.barcodeState.trigger(async () => {
            const unit = await this.props.barcodeScanForUnits(this.props.units)
            await this.props.onSelect(unit)
        })
    }

    public tryRender = () => {
        const disabled = this.props.units.length === 0

        switch (this.state.barcodeState.status) {
            case 'in-progress':
                return <Pulse />
            default:
                return (
                    <div
                        className={classNames('AppCore__unit__BarcodeButton', { disabled }, this.props.className)}
                        onClick={!disabled && this.onClick}
                    >
                        <div className="AppCore__unit__BarcodeButton_image">
                            <img className="AppCore__unit__BarcodeButton_img" src="shared/images/barcode.svg" />
                        </div>
                        <div className="AppCore__unit__BarcodeButton_text">{this.props.children}</div>
                    </div>
                )
        }
    }
}
